import Ajv from 'ajv';

export function validateJson(text: string, schema?: object): boolean {
  let jsonObj;
  try {
    jsonObj = JSON.parse(text);
  } catch (e) {
    return false;
  }

  if (!schema) {
    return true;
  }

  const ajv = new Ajv();
  const validate = ajv.compile(schema);
  const valid = validate(jsonObj);

  return Boolean(valid);
}
